import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import compact from 'lodash/compact';
import RoomType from './RoomType';
import { Box } from 'roo-ui/components';
import { useInView } from 'react-intersection-observer';
import PhoneFilters from 'pages/Property/PropertyAvailability/RoomTypes/PhoneFilters';
import TreatmentToggle from 'components/TreatmentToggle';

const RoomTypeList = ({ showPhoneFilters, ...rest }) => {
  const [visible, setVisible] = useState();
  const [wrapperRef, wrapperInView] = useInView();
  const [footerRef, footerInView] = useInView();

  useEffect(() => {
    const visible = wrapperInView && !footerInView;

    setVisible(visible);
  }, [footerInView, wrapperInView]);

  return (
    <Fragment>
      <Box ref={wrapperRef} overflow={['hidden', 'inherit']}>
        <RoomTypes {...rest} />
        <TreatmentToggle split="property_page_filters" treatment="on">
          {showPhoneFilters && <PhoneFilters visible={visible} />}
        </TreatmentToggle>
      </Box>
      <Box ref={footerRef} />
    </Fragment>
  );
};

RoomTypeList.propTypes = {
  showPhoneFilters: PropTypes.bool,
};

RoomTypeList.defaultProps = {
  showPhoneFilters: false,
};

const RoomTypes = ({ roomTypes, hasQuery }) =>
  compact(roomTypes.map((roomType) => <RoomType roomType={roomType} hasQuery={hasQuery} key={roomType.id} />));

RoomTypes.defaultProps = {
  roomTypes: [],
};
RoomTypes.displayName = 'RoomTypes';
RoomTypes.propTypes = {
  hasQuery: PropTypes.bool.isRequired,
  roomTypes: PropTypes.array,
};

export default RoomTypeList;
